// extracted by mini-css-extract-plugin
export default {"logo":"Register_logo__UUgex","regcont":"Register_regcont__AYjm0","head":"Register_head__bsl8M","form":"Register_form__b1ixy","alrdrgstr":"Register_alrdrgstr__+q8ys"};